export function getTablesOrigin() {
  const origin =
    process.env.NEXT_PUBLIC_ZAPIER_ORIGIN?.replace("https://", "") ||
    "zapier.com";
  return `tables.${origin}`;
}

export function getInterfacesOrigin() {
  const origin =
    process.env.NEXT_PUBLIC_ZAPIER_ORIGIN?.replace("https://", "") ||
    "zapier.com";
  return `interfaces.${origin}`;
}

export function getZslApiOrigin() {
  if (
    process.env.NEXT_PUBLIC_VERCEL_ENV === "development" &&
    process.env.LOCAL_ZSL_API_ORIGIN
  ) {
    return process.env.LOCAL_ZSL_API_ORIGIN.replace("https://", "");
  }
  const origin =
    process.env.NEXT_PUBLIC_ZAPIER_ORIGIN?.replace("https://", "") ||
    "zapier.com";
  return `zsl-api.${origin}`;
}

export function getChatbotsApiOrigin() {
  const origin =
    process.env.NEXT_PUBLIC_ZAPIER_ORIGIN?.replace("https://", "") ||
    "zapier.com";
  return `chatbotsapi.${origin}`;
}
